var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWrench(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_791_14552)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.12532 9.91728C7.62569 9.0131 7.41839 7.97636 7.53191 6.94958C7.64543 5.92279 8.0742 4.95638 8.75928 4.18318C9.44436 3.40998 10.3521 2.86796 11.3578 2.63163C12.3634 2.39529 13.4176 2.47625 14.3753 2.86337L11.2503 6.25009L11.6925 8.3079L13.7503 8.75009L17.137 5.62509C17.5242 6.58285 17.6051 7.63701 17.3688 8.64266C17.1325 9.6483 16.5904 10.5561 15.8172 11.2411C15.044 11.9262 14.0776 12.355 13.0508 12.4685C12.0241 12.582 10.9873 12.3747 10.0831 11.8751L5.70345 16.9532C5.35121 17.3055 4.87347 17.5033 4.37532 17.5033C3.87718 17.5033 3.39944 17.3055 3.0472 16.9532C2.69496 16.601 2.49707 16.1232 2.49707 15.6251C2.49707 15.1269 2.69496 14.6492 3.0472 14.297L8.12532 9.91728Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_791_14552"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrench);
export default __webpack_public_path__ + "static/media/wrench.594ca11d60f660d5e6f4c11d8c18a22c.svg";
export { ForwardRef as ReactComponent };